module.exports = __webpack_public_path__ + "static/media/veilederguide1.9fa2ca47.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dialogduk/static/veilederguide1.png
// module id = 159
// module chunks = 0